import { For, Show } from "solid-js";
import InlineMessage from "../components/inlineMessage/InlineMessage";
import type { Issue } from "../state/validation";
import { useTranslation } from "../state/i18n";
import { isEmpty } from "lodash-es";

type GlobalErrorInlineMessageProps = {
  errors: Issue[] | undefined;
};

const GlobalErrorInlineMessage = (props: GlobalErrorInlineMessageProps) => {
  const { t } = useTranslation();

  return (
    <Show when={!isEmpty(props.errors) && props.errors}>
      {(errors) => (
        <InlineMessage variant="danger">
          <span>{t(($) => $.FIELD_ERROR_INLINE_MESSAGE_DESCRIPTION)}</span>
          <ul class="ml-5 list-outside list-disc">
            <For each={errors()}>{(error) => <li>{error.message}</li>}</For>
          </ul>
        </InlineMessage>
      )}
    </Show>
  );
};

export default GlobalErrorInlineMessage;
